﻿export class SearchCases {
    FirstName: string;
    LastName: string;
    DOB: string;
    FileNumber: string;
    CaseNumber: string;
    ChildNumber: string;
    UserID: number;

    constructor() {
        this.FirstName = "";
        this.LastName = "";
        this.DOB = "";
        this.FileNumber = "";
        this.CaseNumber = "";
        this.ChildNumber = "";
        this.UserID = -1;
    }
}

